module.exports = "<div [ngClass]=\"checkIsOnTheme()? 'icon-theme-on': 'icon-theme'\" [title]=\"checkIsOnTheme()?'Turn off theme':'Turn on theme'\" class=\"select select-icon\" (click)=\"_onThemeAction()\">\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/surveys/master-summary/icon-dropdown/theme-icon/theme-icon.component.html
// module id = ./src/app/routes/surveys/master-summary/icon-dropdown/theme-icon/theme-icon.component.html
// module chunks = main